module.exports = __webpack_public_path__ + "static/media/quadrant-dweb-curious-relevant-area.d1ca81a8.svg";